import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import getCompanyList from '@entities/company/api/company';
import { updateCompany, getRejectList } from '@entities/company/api/company';

/**
 * 회사 목록 조회용 React Query 커스텀 훅
 * - getCompanyList API를 호출하여 회사 리스트 데이터를 비동기로 가져옴
 * - React Query의 캐싱, 로딩, 에러 상태를 자동 관리함
 */
function useCompanyListQuery() {
  return useQuery({
    queryKey: ['companyList'],
    queryFn: getCompanyList,
    select(data) {
      return data?.resultData?.companyList ?? [];
    },
    // 회사 목록은 거의 변경되지 않으므로 1시간 캐싱
    staleTime: 1000 * 60 * 60,
  });
}

export default useCompanyListQuery;
/**
 * 회사 수정용 React Query Mutation 훅
 * - 회사 수정 성공 시 회사 목록 캐시 무효화
 */
export function useUpdateCompanyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCompany,

    onSuccess() {
      // 회사 정보 수정 후 목록 다시 조회
      queryClient.invalidateQueries({ queryKey: ['companyList'] });
    },
  });
}
/**
 * 수신자 거부 리스트 조회용 React Query 커스텀 훅
 *
 * @param {Object} params
 * @param {number} params.company - 회사 코드
 * @param {number} params.teamCode - 팀 코드
 */
export function useRejectListQuery({ company, teamCode }) {
  return useQuery({
    queryKey: ['rejectList', company, teamCode],
    queryFn: () => getRejectList({ company, teamCode }),
    enabled: Boolean(company && teamCode), // 파라미터 준비되었을 때만 실행
    select(data) {
      return data?.resultData ?? [];
    },
  });
}
